import { Console } from "console";
import React, { ChangeEvent, JSX, useState, SyntheticEvent } from "react";

interface Props {
  onSearchClick: (e: SyntheticEvent) => void;
  search: string | undefined;
  handleSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const Search: React.FC<Props> = ({
  onSearchClick,
  search,
  handleSearchChange,
  handleKeyDown,
}: Props): JSX.Element => {
  return (
    <section className="relative bg-gray-100">
      <div className="max-w-4xl mx-auto p-6 space-y-6">
        <input
          className="flex-1 p-3 border-2 rounded-lg placeholder-black focus:outline-none"
          id="search-input"
          placeholder="Search companies"
          value={search}
          onChange={(e) => handleSearchChange(e)}
          onKeyDown={handleKeyDown}
        ></input>
        <button onClick={(e) => onSearchClick(e)} />
      </div>
    </section>
  );
};

export default Search;
